export default __webpack_public_path__ + "03e629f6348896ffa23aac276369bf64.ttf";